import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { breakpoints } from 'theme';

export const StepperRoot = styled.nav`
  display: flex;
  align-items: flex-start;
  margin-bottom: 36px;
  width: 100%;
  min-width: 0;

  @media ${breakpoints.downSmPlus} {
    margin-bottom: 24px;
  }
`;

const itemBase = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  min-width: 0;
`;

const connector = css<{ $isLast?: boolean; $doneConnector?: boolean }>`
  ${({ $isLast, theme, $doneConnector }) =>
    !$isLast &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: 13px;
        left: 50%;
        width: 100%;
        height: 2px;
        background: ${$doneConnector
          ? theme.color.brightTurquoise
          : theme.color.porcelain};
        z-index: 0;
        transition: background 0.3s;
      }
    `}
`;

const interactiveItem = css`
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-decoration: none;

  &:hover [data-stepper-dot],
  &:focus-visible [data-stepper-dot] {
    filter: brightness(1.05);
    box-shadow: 0 0 0 4px ${({ theme }) => theme.color.brightTurquoise}33;
  }

  &:focus-visible {
    outline: none;
  }

  &:active [data-stepper-dot] {
    transform: scale(0.96);
  }
`;

export const StepperItemStatic = styled.div<{
  $isLast?: boolean;
  $doneConnector?: boolean;
}>`
  ${itemBase};
  ${connector};
`;

export const StepperItemButton = styled.button<{
  $isLast?: boolean;
  $doneConnector?: boolean;
}>`
  ${itemBase};
  ${connector};
  ${interactiveItem};
`;

export const StepperItemLink = styled(Link)<{
  $isLast?: boolean;
  $doneConnector?: boolean;
}>`
  ${itemBase};
  ${connector};
  ${interactiveItem};
`;

export const StepperDot = styled.div<{ $active?: boolean; $done?: boolean }>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.color.porcelain};
  background: ${({ theme }) => theme.color.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.baliHai};
  z-index: 1;
  position: relative;
  transition: all 0.2s;

  ${({ theme, $active }) =>
    $active &&
    `
    border-color: ${theme.color.skobeloffGreen};
    background: ${theme.color.skobeloffGreen};
    color: ${theme.color.white};
  `}

  ${({ theme, $done }) =>
    $done &&
    `
    border-color: ${theme.color.brightTurquoise};
    background: ${theme.color.brightTurquoise};
    color: ${theme.color.white};
  `}
`;

export const StepperLabel = styled.div<{ $active?: boolean; $done?: boolean }>`
  font-size: 11px;
  color: ${({ theme }) => theme.color.baliHai};
  margin-top: 5px;
  text-align: center;
  line-height: 1.3;
  padding: 0 2px;
  word-break: break-word;

  @media ${breakpoints.downSmPlus} {
    font-size: 10px;
  }

  ${({ theme, $active }) =>
    $active &&
    `
    color: ${theme.color.pickledBluewood};
    font-weight: 600;
  `}

  ${({ theme, $done }) =>
    $done &&
    `
    color: ${theme.color.brightTurquoise};
  `}
`;
